import {DispatchRequestEntity} from "@ots-frontend/ots-data";
import {useEntityDataGrid, UseEntityDataGridProps, UseEntityDataGridResult} from "../EntityDataGrid/useEntityDataGrid";
import {useDispatchRequestDataGridCols} from "./useDispatchRequestDataGridCols";

export const EMPTY_ARRAY: DispatchRequestEntity[] = []

export type UseDispatchRequestDataGridProps = Omit<UseEntityDataGridProps<DispatchRequestEntity>, 'colsMap'>

export function useDispatchRequestDataGrid(props: UseDispatchRequestDataGridProps): UseEntityDataGridResult<DispatchRequestEntity> {
  const {data = EMPTY_ARRAY, colWidths, ...rest} = props;

  const {colsMap} = useDispatchRequestDataGridCols({colWidths: colWidths})

  return useEntityDataGrid<DispatchRequestEntity>({
    ...rest,
    colsMap: colsMap,
    colWidths: colWidths,
    data: data,
  })
}
